/**
 * Application Layout Component
 * 
 * Provides the main layout structure with a persistent header and bottom navigation.
 */

import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { BottomNavigation } from './BottomNavigation';
import { TradeConfigurationDialog } from '../trading/TradeConfigurationDialog';

export function AppLayout() {
  const location = useLocation();
  const [isTradeDialogOpen, setIsTradeDialogOpen] = useState(false);
  
  // Determine header props based on current route
  const getHeaderProps = () => {
    switch (location.pathname) {
      case '/dashboard':
        return {};
      case '/positions':
        return {
          pageTitle: 'Accounts',
          pageDescription: 'View and manage your connected brokerage accounts and holdings.'
        };
      case '/trading':
        return {
          pageTitle: 'Algo Performance'
        };
      case '/settings':
        return {
          pageTitle: 'Settings'
        };
      case '/debug':
        return {
          pageTitle: 'Debug'
        };
      case '/webhook-stocks':
        return {
          pageTitle: 'Stocks',
          pageDescription: 'Manage stocks traded via TradingView webhooks'
        };
      default:
        return {};
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-black">
      {/* Main content area with padding for floating bottom nav on mobile */}
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 pt-5 pb-28 sm:pt-8 sm:pb-8">
        <AppHeader {...getHeaderProps()} />
        <Outlet context={{ isTradeDialogOpen, setIsTradeDialogOpen }} />
      </div>

      {/* Bottom Navigation - Mobile Only */}
      <BottomNavigation />

      {/* Trade Configuration Dialog */}
      <TradeConfigurationDialog
        isOpen={isTradeDialogOpen}
        onClose={() => setIsTradeDialogOpen(false)}
      />
    </div>
  );
}
